import { Component, inject, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, combineLatest, filter } from 'rxjs';
import { MCProgressBarComponent, MCStepsComponent } from '@maslul/common-components';
import { ProgressService } from '../../../services/shared/progress';

@Component({
    selector: 'mi-app-progress',
    imports: [
        MCProgressBarComponent,
        MCStepsComponent
    ],
    templateUrl: './progress.html',
    styleUrls: ['./progress.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppProgressComponent {
    private progressService = inject(ProgressService);

    currentTabTitle: any;

    activeTabs = toSignal(combineLatest([
        this.progressService.activeTabs$,
        this.progressService.currentStep$
    ]).pipe(
        filter(([items]) => items.length !== 0),
        map(([items, activeIndex]) => {
            this.currentTabTitle = items[activeIndex - 1].label;
            return items.map((item, index) => {
                if ((index + 1) < activeIndex) {
                    return { ...item, styleClass: 'mi-completed' };
                }
                return { ...item, styleClass: '' };
            });
        })
    ));

    currentStep = toSignal(this.progressService.currentStep$);

    totalSteps = toSignal(this.progressService.activeTabs$.pipe(
        map(tabs => tabs.length),
    ));

    currentTabIndex = toSignal(this.progressService.currentStep$, { initialValue: 0 });

    progressValue = toSignal(combineLatest([
        this.progressService.currentStep$,
        this.progressService.activeTabs$.pipe(map(tabs => tabs.length))
    ]).pipe(
        map(([current, total]) => {
            return total > 0 ? (current / total) * 100 : 0;
        })
    ));
}
